import React from 'react'
import PropTypes from 'prop-types'
import I18n from 'i18n'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const IntegrationsFallback = ({ fetchError }) => {
  const scope = fetchError ? 'components.integrations.error' : 'components.integrations.empty'
  const icon = fetchError ? 'exclamation-triangle' : 'info-circle'

  return (
    <div className='timeline-card timeline-placeholder' data-testid='integrations-fallback'>
      <div className='text-l text-heavy text-primary-color timeline-title center-align'>
        <div className='bigger-icon center-align'>
          <FontAwesomeIcon icon={icon} />
        </div>
        <p>{I18n.t(`${scope}.title`)}</p>
        <p className='text-muted text-m text-medium'>{I18n.t(`${scope}.description`)}</p>
      </div>
    </div>
  )
}

IntegrationsFallback.propTypes = {
  fetchError: PropTypes.bool
}

IntegrationsFallback.defaultProps = {
  fetchError: false
}

export default IntegrationsFallback
